import { z } from "zod";
import "../zod-runtime.js";
export const workflowStatusSchema = z.enum(["draft", "example", "approved"]);
export const verificationStateSchema = z.enum([
    "needs_capture",
    "video_captured",
    "verified",
]);
export const sideSchema = z.enum(["T", "CT"]);
export const slotSchema = z.enum(["P1", "P2", "P3", "P4", "P5"]);
/**
 * `viewer` darf den Editor lesen, aber nichts schreiben; `editor` pflegt
 * Inhalte; nur `captain` gibt frei, veröffentlicht und verwaltet Mitglieder.
 */
export const memberRoleSchema = z.enum(["viewer", "editor", "captain"]);
export const utilityTypeSchema = z.enum([
    "SMOKE",
    "MOLLY",
    "FLASH",
    "HE",
    "C4",
    "DECOY",
]);
export const mapElementTypeSchema = z.enum([
    "player_route",
    "step_marker",
    "player_marker",
    "utility_target",
    "effect_area",
    "callout",
    "arrow",
    "text",
    "highlight_area",
]);
